import React from 'react';

import { VariantLoading } from '../next/variant/variant-loading';

export const VariantGridItemSkeleton = () => (
  <VariantLoading className="col-span-3" />
);
